<template>
    <div id="learnCenter" :class="$root.isMob() ? 'mob' : ''" v-loading="loading">
        <div v-if="loading" class="loadingAlert">
            <el-alert
                title="加载中"
                description="正在加载数据,这可能需要一些时间,请稍后..."
                type="warning"
                center
                show-icon
                :closable="false">
            </el-alert>
        </div>
        <div class="title">
            <h2><i class="el-icon-notebook-2 icon"></i>云课堂</h2>
        </div>
        <div class="list">
            <div ref="cateItem" class="cateItem" v-for="item in cate" :key="'cate_'+item.id">
                <h2 class="title">{{item.name}}</h2>
                <div class="item" v-for="i in item.data" :key="'item_'+i.id" @click="view(i)">
                    <div class="img">
                        <img :src="API + i.cover_img"/>
                    </div>
                    <div class="content">
                        <div class="title">
                            <span class="name">{{ i.name }}</span>
                        </div>
                        <div class="describe">
                            {{ i.remark }}
                        </div>
                    </div>
                </div>

                <div class="empty" v-if="item?.data?.length == 0">
                    <el-empty description="暂无数据"></el-empty>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
  name: 'learnCenter',
  props: {
  },
  watch: {
    "currentPage" () {
        this.getList(this.currentCate,this.currentPage);
    },
    "currentCate"(){
        this.getList(this.currentCate,1);
    },
    "cate"(){
        if(this.cate.length > 0){
            this.loading = false;
        }
    }
  },
  data() {
    return {
        loading:true,
        data:[],
        cate:[],
        currentCate:0,
        API: window.config.api,
        lastPage:1,
        currentPage:1,
    }
  },
  methods: {
    async getList(cate=0,page=1){
        let data = await this.$root.getLearnList('',cate,page,9999);
        this.data = data.data.data;
        this.data.forEach(item => {
            let strLeng = item.remark.length;
            item.remark = item.remark.substring(0,150);
            if(strLeng > 150){
                item.remark = item.remark + "...";
            }            
        });        
        this.lastPage = data.data.last_page;
    },
    async getCate(){
        this.loading = true;
        let data = await this.$root.getLearnCate();
        this.cate = data.data;

        await this.getList(0,this.page);
        let listData = this.data;   
        this.cate.forEach((cateItem,key) => { 
            this.cate[key].data = [];
            listData.forEach(item => {
                if(cateItem.id == item.cat_id){                    
                    let strLeng = item.remark.length;
                    item.remark = item.remark.substring(0,10);
                    if(strLeng > 10){
                        item.remark = item.remark + "...";
                    }   

                    strLeng = item.name.length;
                    item.name = item.name.substring(0,10);
                    if(strLeng > 10){
                        item.name = item.name + "...";
                    }  
                    this.cate[key].data.push(item);  
                }
            });
        })
        this.$forceUpdate();
        this.loading = false;
    },
    changePage(page){
        this.currentPage = page;        
    },
    changeCate(type){
        this.currentCate = type;
    },
    view(item){
        this.$emit('viewDetail',item.id,item.name);
    },
  },
  created() {
    this.getCate();
  }
}
</script>
<style scoped lang="scss" src="@/assets/css/lib/learnCenter.scss">
</style>